export enum PaymentPlanType {
  LICENSE_NONE = 0,
  YEARLY = 1,
  MONTHLY = 2,
}
